var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// window.moment = moment;
// require('bootstrap-five');

// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
require('bootstrap-five/js/dist/collapse');
require('bootstrap-five/js/dist/tab');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/accordion');
window.Dropdown = require('bootstrap-five/js/dist/dropdown');
// require('bootstrap-five/js/dist/tab');
require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/tooltip');

require('bootstrap-select');


import Swiper from 'swiper';
// import { Navigation, Pagination, LazyLoading } from 'swiper/modules';

require('masonry-layout/dist/masonry.pkgd');
// const WOW = require('wow.js');

// import Swiper from 'swiper/bundle';
// window.Swiper = Swiper;
// import '/js/plugins/slider-menu.js';


// require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');


require('magnific-popup');

import Headroom from 'headroom.js';

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    var header = document.querySelector('#header');

    if (header && Headroom.cutsTheMustard) {
        var navBgTimeout;

        function applyNavScrolledBg() {
            if (header.classList.contains('headroom--not-top')) {
                header.classList.add('bg-scroll');
            }
        }

        new Headroom(header, {
            offset: 50,
            tolerance: {
                up: 5,
                down: 0,
            },
            onNotTop: function() {
                window.clearTimeout(navBgTimeout);
                // Wait until the unpin animation has finished so the first hide stays transparent
                navBgTimeout = window.setTimeout(applyNavScrolledBg, 450);
            },
            onPin: function() {
                window.clearTimeout(navBgTimeout);
                applyNavScrolledBg();
            },
            onTop: function() {
                window.clearTimeout(navBgTimeout);
                header.classList.remove('bg-scroll');
            },
        }).init();
    }



    $(window).on('resize load scroll', function() {
        $('.grid').masonry({
        // options
            itemSelector: '.grid-item',
            gutter: 0
        });
    });

    $('.pop-image').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },

    });

    var gallerySwiper = null;
    var $galleryModal = $('#galleryModal');
    var pendingGalleryIndex = 0;

    // slidesPerView:'auto' needs image dimensions before loop clones are correct
    function whenGalleryImagesReady($swiperEl, callback) {
        var $imgs = $swiperEl.find('.swiper-slide img');
        var pending = $imgs.length;

        if (!pending) {
            callback();
            return;
        }

        $imgs.each(function () {
            if (this.complete) {
                if (--pending === 0) {
                    callback();
                }
                return;
            }

            $(this).one('load error', function () {
                if (--pending === 0) {
                    callback();
                }
            });
        });
    }

    function initGallerySwiper(startIndex) {
        var $swiperEl = $galleryModal.find('.gallery-modal-swiper');

        if (gallerySwiper) {
            gallerySwiper.destroy(true, true);
            gallerySwiper = null;
        }

        $swiperEl.css('visibility', 'hidden');

        whenGalleryImagesReady($swiperEl, function () {
            if (!$galleryModal.hasClass('show')) {
                return;
            }

            gallerySwiper = new Swiper($swiperEl[0], {
                initialSlide: startIndex,
                loop: true,
                loopAdditionalSlides: 5,
                centeredSlides: true,
                slidesPerView: 'auto',
                spaceBetween: 10,
                speed: 1000,
            });

            gallerySwiper.update();
            gallerySwiper.loopFix();
            gallerySwiper.slideToLoop(startIndex, 0, false);
            $swiperEl.css('visibility', 'visible');
        });
    }

    // Capture index while relatedTarget is available; init after modal is visible
    $galleryModal.on('show.bs.modal', function (e) {
        var index = parseInt($(e.relatedTarget).closest('[data-slide-index]').attr('data-slide-index'), 10);
        pendingGalleryIndex = isNaN(index) ? 0 : index;
    });

    $galleryModal.on('shown.bs.modal', function () {
        initGallerySwiper(pendingGalleryIndex);
    });

    $galleryModal.on('hidden.bs.modal', function () {
        if (gallerySwiper) {
            gallerySwiper.destroy(true, true);
            gallerySwiper = null;
        }
    });

    $galleryModal.on('click', '.swiper-button-next', function (evt) {
        evt.preventDefault();
        if (gallerySwiper) {
            gallerySwiper.slideNext();
        }
    });

    $galleryModal.on('click', '.swiper-button-prev', function (evt) {
        evt.preventDefault();
        if (gallerySwiper) {
            gallerySwiper.slidePrev();
        }
    });



    // new WOW().init({});


    /* $('#btn-menu').on('click', function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    }); */


    var video = document.getElementById("heroVideo");

    $('#btn-pause').on('click', function() {
        video.pause();
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-play").addClass('d-flex').removeClass('d-none');
    });

    $('#btn-play').on('click', function() {
        video.play();
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-pause").addClass('d-flex').removeClass('d-none');
    });

    $('#btn-mute').on('click', function() {
        $(video).prop('muted', false);
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-volume").addClass('d-flex').removeClass('d-none');
    });

    $('#btn-volume').on('click', function() {
        $(video).prop('muted', true);
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-mute").addClass('d-flex').removeClass('d-none');
    });

    $('#btn-menu').on('click', function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
        $(this).text($(this).text() == 'Close' ? 'Menu' : 'Close');

        // Toggle header-wh if on dark theme
        if ($('.main-nav').attr('data-bs-theme') === 'dark') {
           $('#header').toggleClass('header-wh');

        }

    });

     // Plan modal close button stays visible; Bootstrap handles modal show/hide.
     // Clear any leftover inline hide from older enlarge/close toggles.
     $(document).on('show.bs.modal', '.modal--plan', function () {
        $(this).find('.btn-plan-close, .btn-view-close').css('visibility', '');
     });

    $('.selectpicker').selectpicker();
    // $(document).on('click', '#btn-enlarge', function() {
    //     $('#btn-menu').css('visibility', 'hidden');
    // });
    // $(document).on('hidden.bs.modal', '#btn-menu', function() {
    //     $('#btn-menu').css('visibility', '');
    // });




    // $(window).on('resize load scroll', function() {
    // // var headerHeight = $('.navbar--main').outerHeight();
    //     var scroll = $(window).scrollTop();

    //     if (scroll >= 48 ) {  //scroll top menu out of view
    //         $('#header').addClass("down");
    //     } else {
    //         $('#header').removeClass("down");
    //     }
    // });






    if ($('.pop-youtube, .pop-inline').length) {
        $('body').addClass('youtube-modal');

        $('.pop-youtube, .pop-inline').magnificPopup({
            gallery: {
                enabled: true
            },
            callbacks: {
                elementParse: function(item) {
                    // Set type based on element class
                    if (item.el) {
                        var $el = $(item.el);
                        if ($el.hasClass('pop-inline')) {
                            item.type = 'inline';
                        } else if ($el.hasClass('pop-youtube')) {
                            item.type = 'iframe';
                        }
                    }
                },
                beforeChange: function() {
                    // Set type before content changes during navigation
                    if (this.currItem && this.currItem.el) {
                        var $el = $(this.currItem.el);
                        if ($el.hasClass('pop-inline')) {
                            this.currItem.type = 'inline';
                        } else if ($el.hasClass('pop-youtube')) {
                            this.currItem.type = 'iframe';
                        }
                    }
                },
                open: function() {
                    // Ensure video poster shows when first opened
                    if (this.currItem && this.currItem.type === 'inline') {
                        var self = this;
                        setTimeout(function() {
                            var video = self.content.find('video')[0];
                            if (video) {
                                video.pause();
                                video.currentTime = 0;
                                video.load();
                            }
                        }, 10);
                    }
                },
                change: function() {
                    // Reset inline videos when navigating to show poster
                    if (this.currItem && this.currItem.type === 'inline') {
                        var self = this;
                        setTimeout(function() {
                            var video = self.content.find('video')[0];
                            if (video) {
                                video.pause();
                                video.currentTime = 0;
                                video.load();
                            }
                        }, 50);
                    }
                },
                buildControls: function() {
                    if (this.arrowLeft && this.arrowRight) {
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    }
                },
                close: function() {
                    // Stop videos when modal closes
                    this.content.find('video').each(function() {
                        this.pause();
                        this.currentTime = 0;
                    });
                    this.content.find('iframe').each(function() {
                        this.src = '';
                    });
                },
            },
        });
    }
    if (document.readyState === 'complete') {
        initFlipbook();
    } else {
        $(window).on('load', initFlipbook);
    }

});

function initFlipbook(retries) {
    var $el = $('#flipbook');
    if (!$el.length) {
        return;
    }

    var pdf = $el.data('src');
    if (!pdf || typeof $.fn.flipBook !== 'function' || typeof DFLIP === 'undefined') {
        if ((retries = retries === undefined ? 50 : retries) > 0) {
            window.setTimeout(function () {
                initFlipbook(retries - 1);
            }, 100);
        }
        return;
    }

    // Apply asset paths before flipBook() — DFlip only does this on document.ready,
    // which can race with init and leave relative pdf.js URLs that 404.
    var dflipLocation = (window.dFlipLocation || '/dflip/').replace(/\/?$/, '/');
    $.extend(DFLIP.defaults, {
        mockupjsSrc: dflipLocation + 'js/libs/mockup.min.js',
        pdfjsSrc: dflipLocation + 'js/libs/pdf.min.js',
        pdfjsCompatibilitySrc: dflipLocation + 'js/libs/compatibility.js',
        pdfjsWorkerSrc: dflipLocation + 'js/libs/pdf.worker.min.js',
        threejsSrc: dflipLocation + 'js/libs/three.min.js',
        soundFile: dflipLocation + 'sound/turn2.mp3',
        imagesLocation: dflipLocation + 'images',
        imageResourcesPath: dflipLocation + 'images/pdfjs/',
        cMapUrl: dflipLocation + 'js/libs/cmaps/',
    });

    $el.flipBook(pdf, {
        webgl: false,
        height: '100%',
        forceFit: true,
        enableDownload: false,
        scrollWheel: false,
        hideControls: 'share',
    });
}

window.recaptchaInit = function (parent) {
    let gClass = '.g-recaptcha';
    if (parent !== undefined) {
        gClass = parent + ' .g-recaptcha';
    }
    $(gClass).each(function() {
        var el = $(this);
        if (grecaptcha) {
            try {
                grecaptcha.render($(el).attr("id"), {});
            } catch(error){
                // duplicate errors
            }
        }
    });
    window.dispatchEvent(new CustomEvent('recaptcha-init'));
}
